export { BodyScrollLock } from './bodyScrollLock.component';
